export const brandLogoUrl = (brandId) => {
  return `/images/brands/${brandId}-small.png`;
};
